import { ValidationError, useForm } from '@formspree/react'
import { CheckCircle2, Send } from 'lucide-react'
import { Button, Input, Textarea } from '@/components/ui'

export default function ContactForm() {
  const [state, handleSubmit] = useForm('xqagqjkj')

  if (state.succeeded) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 10px' }}>
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            margin: '0 auto 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--emerald-50)',
            color: 'var(--emerald-700)',
          }}
        >
          <CheckCircle2 size={34} />
        </div>
        <h2 style={{ fontSize: 'var(--text-h3)', margin: '0 0 10px' }}>
          Message envoyé
        </h2>
        <p style={{ fontSize: 16, color: 'var(--ink-2)' }}>
          Merci de nous avoir écrit. Nous revenons vers vous très vite.
        </p>
      </div>
    )
  }

  return (
    <form
      onSubmit={handleSubmit}
      style={{ display: 'flex', flexDirection: 'column', gap: 18 }}
    >
      <div
        className="oumma-set-grid"
        style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}
      >
        <Input label="Nom" name="name" placeholder="Votre nom" required />
        <Input
          label="E-mail"
          name="email"
          type="email"
          placeholder="vous@email.fr"
          required
        />
      </div>
      <ValidationError prefix="Email" field="email" errors={state.errors} />
      <Input
        label="Sujet"
        name="subject"
        placeholder="L'objet de votre message"
      />
      <Textarea
        label="Message"
        name="message"
        rows={5}
        placeholder="Comment pouvons-nous vous aider ?"
        required
      />
      <ValidationError prefix="Message" field="message" errors={state.errors} />
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="primary"
          size="lg"
          type="submit"
          loading={state.submitting}
          iconLeft={<Send size={18} />}
        >
          Envoyer le message
        </Button>
      </div>
    </form>
  )
}
